// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","849":"7f7514a1","977":"f49d09dd"}[chunkId] + ".chunk.js";
};